var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 107,
    viewBox: "0 0 108 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 53.5,
    r: 48.5,
    fill: "#F1F2F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 53.5,
    r: 51,
    stroke: "#F1F2F9",
    strokeOpacity: 0.2,
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.6666 61.9036V41.7869C70.6666 39.7869 69.0333 38.3036 67.0499 38.4702H66.9499C63.4499 38.7702 58.1333 40.5536 55.1666 42.4202L54.8833 42.6036C54.3999 42.9036 53.5999 42.9036 53.1166 42.6036L52.6999 42.3536C49.7333 40.5036 44.4333 38.7369 40.9333 38.4536C38.9499 38.2869 37.3333 39.7869 37.3333 41.7702V61.9036C37.3333 63.5036 38.6333 65.0036 40.2333 65.2036L40.7166 65.2702C44.3333 65.7536 49.9166 67.5869 53.1166 69.3369L53.1833 69.3702C53.6333 69.6202 54.3499 69.6202 54.7833 69.3702C57.9833 67.6036 63.5833 65.7536 67.2166 65.2702L67.7666 65.2036C69.3666 65.0036 70.6666 63.5036 70.6666 61.9036Z",
    stroke: "#5575F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54.0001 43.1465V68.1465M46.9167 48.1465H43.1667M48.1667 53.1465H43.1667",
    stroke: "#5575F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.c28c86ef6aa667c5f4ca18f4af1d1250.svg";
export { ForwardRef as ReactComponent };